import {BruteForce} from "../BruteForce";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";

export class BruteForceBonusOutroPresentation implements SimplePresentation {
    name: string = "BruteForceBonusOutroPresentation";

    shouldRun(): boolean {
        return BruteForce.model.mode !== BruteForceGameMode.NORMAL && BruteForce.model.nextMode === BruteForceGameMode.NORMAL && !BruteForce.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        controller.setSkipCallback();
        BruteForce.keypadPlugin.setZeroBetSpinCounter(-1);
        tl.to(this, {duration: 1});
        tl.add(BruteForce.bonusOutroView.showOutro());
        tl.add(BruteForce.transitionView.enableButton(() => this.complete(controller)));
    }

    public complete(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(BruteForce.bonusOutroView.hideFSOutro());
        tl.add(() => {
            controller.setSkipCallback();
            controller.finish();
            BruteForce.keypadPlugin.show();
        });
    }
}